import React from 'react';
import { BookOpenIcon, GiftIcon, MountainIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 tomos completos'
}, {
  icon: GiftIcon,
  label: '5 bonos estratégicos'
}, {
  icon: MountainIcon,
  label: '+300 recursos listos para usar'
}, {
  icon: UsersIcon,
  label: 'Docentes, estudiantes y profesionales'
}];
export function SocialProof() {
  return <section className="border-b border-line bg-white py-5" aria-label="Contenido del Mega Pack" data-id="element-215" data-mp="3f4xkogab3mi">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-muted sm:justify-between" data-id="element-216" data-mp="8doiqmn20bdt">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-217" data-mp="3usr3d2sbgqih">
            <Icon className="h-5 w-5 text-sage" aria-hidden="true" data-id="element-218" data-mp="mdzart03nw0k" /> {label}
          </span>)}
      </div>
    </section>;
}